import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormControl } from '@angular/forms';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
})
export class FormErrorComponent implements OnInit {
  @Input() control: AbstractControl;
  @Input() minLength: number;
  @Input() maxLength: number;
  @Input() pattern: string;

  constructor() { }

  ngOnInit() { }

}
